import * as Yup from 'yup';

export const LookupPriceSchema = Yup.object().shape({
    // Price is optional. If provided, it must be a positive whole number greater than 0.
    price: Yup.string()
        .test('is-valid-price', 'Price must be a positive whole number greater than ₦0', (value) => {
            if (!value || value === '') return true; // optional — empty is valid
            const parsedPrice = Number(value.toString().replace(/,/g, '').trim());
            return !Number.isNaN(parsedPrice) && parsedPrice > 0 && Number.isInteger(parsedPrice);
        }),
});

export type LookupPriceDataType = Yup.InferType<typeof LookupPriceSchema>;

type InitialValues = {
    price: string;
};

export const LookupPriceInitialValues: InitialValues = {
    price: '',
};

export interface LookupPriceInterface {
    price: string;
}
